import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  form: {
    color: colors.neutral[900],
  },
  formElements: {
    display: 'flex',
    flexDirection: 'column',
    gap: '3rem',
  },
  subtitle: {
    marginBottom: '3rem',
  },
  select: {
    width: '100%',
  },
};

const createStyles = createUseStyles(styles);

export { styles, createStyles };
